import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DialogService } from './dialog.service';

@Injectable({
  providedIn: 'root',
})
export class EventService {
  constructor(private dialogService: DialogService) {}
  /*
  添加监听,需要注意的是，addWatcher方法执行后，传入的handle方法也会执行一次
  * */
  addWatcher(attr: string, handle: any) {
    if (!this.isExistAttr(attr)) {
      // 添加订阅的属性：用来给订阅方存储数据
      this[attr] = new BehaviorSubject<any>(0);
      // 实时接收发布方传递的数据
      this[attr].subscribe(handle);
    } else {
      // this.dialogService.notification.error('订阅失败', '订阅的属性名已经存在!');
    }
  }
  /*
  数据改变时触发，用来接收发布方的数据
  * */
  change(attr: string, data?: any) {
    if (this[attr]) {
      this[attr].next(data);
    }
  }
  /*
  判断订阅的属性是否已经存在
  * */
  isExistAttr(attr: string) {
    return this.hasOwnProperty(attr);
  }
  /*
  页面销毁时，请删除监听属性
  * */
  deleteAttr(attr: string) {
    if (this.isExistAttr(attr)) {
      delete this[attr];
    }
  }
}
